import axios from "axios";
import { joinURLs } from "../utils/urlUtil";
import ErrorHandler from "../utils/ErrorHandler";
import { LiveLogsResponseDto, ResponseStatus } from "../utils/types";
import { Dispatch, SetStateAction } from "react";

export const LiveLogs = {

  getLiveLogs: async (getLiveLogsAbortController: AbortController, tags:string[], setLiveLogsDto: Dispatch<SetStateAction<LiveLogsResponseDto | null>>, scheduleNextRefresh: () => void) => {
    const url = joinURLs("admin/live", process.env.REACT_APP_JUPITER_API_BASE_URL);
    const params = { 'query': tags };
    
    setLiveLogsDto((prevLiveLogsDto:LiveLogsResponseDto) => {
      if (!prevLiveLogsDto) return null;

      return {
        ...prevLiveLogsDto,
        status: ResponseStatus.LOADING,
      };
    });

    try {
      const response:any = await axios.get(url, {
        params,
        withCredentials: true,
        signal: getLiveLogsAbortController.signal
      });

      if (response) {
        setLiveLogsDto({
          status: ResponseStatus.OK, 
          error: null,
          data: response.data
        });
      }
    } catch (error:any) {
      if (!axios.isCancel(error)) {
        const isLoggedOut:boolean = ErrorHandler.handleLoggedOutError(error);
        if (!isLoggedOut){
          const response: LiveLogsResponseDto = {
            status: ResponseStatus.ERROR,
            error: error?.response?.data?.errorMessage || error?.message,
            data: {
              clicks: [],
              conversions: []
            }
          };
          setLiveLogsDto(response);
        }
      }
    }
    scheduleNextRefresh();
  }
}